import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';

const GAP = 24;

/**
 * Kadr kotwicy rozciągnięty w DÓŁ. Bez tego kotwica pod kadrem i kotwica nad kadrem to
 * dla obserwatora ten sam stan „nie przecina", więc przeskok przewijania ponad całą
 * listę nie wywołałby żadnego zgłoszenia i przycisk nigdy by nie wyszedł.
 */
const ANCHOR_MARGIN = '0px 0px 100000px 0px';

/**
 * Powrót na sam początek listy. Sam host jest kotwicą, więc postaw go tam, gdzie lista
 * się zaczyna — przycisk wychodzi dopiero wtedy, gdy to miejsce ucieknie ponad kadr.
 */
@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss']
})
export class ScrollTopComponent implements OnInit, OnDestroy {

  /** Kontener ze scrollem tej listy. Bez niego kadrem jest okno, a wracamy na górę strony. */
  @Input() scrollRoot: Element = null;

  visible = false;

  readonly anchorMargin = ANCHOR_MARGIN;

  private button: HTMLElement;
  private readonly reposition = () => this.place();

  constructor(private host: ElementRef, private ngZone: NgZone) {}

  @ViewChild('button') set buttonRef(button: ElementRef) {
    this.button = button && button.nativeElement;
    this.place();
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('resize', this.reposition, { passive: true });
      if (this.scrollRoot) {
        window.addEventListener('scroll', this.reposition, { passive: true });
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition);
  }

  scrollToTop(): void {
    (this.scrollRoot || window).scrollTo({ top: 0, behavior: 'smooth' });
  }

  /**
   * Arkusz nie ma z czego policzyć tego miejsca: przycisk wisi na `position: fixed`,
   * kolumna z listą bywa zwężona o menu i panel VoIP, a dno ramki jedzie ze stroną.
   */
  private place(): void {
    if (!this.button) {
      return;
    }

    const frame = (this.scrollRoot || this.host.nativeElement).getBoundingClientRect();

    this.button.style.left = `${frame.left + frame.width / 2}px`;
    this.button.style.bottom = this.scrollRoot
      ? `${Math.max(GAP, window.innerHeight - frame.bottom + GAP)}px`
      : `${GAP}px`;
  }
}
